import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '../../actions/UpdateBreadcrumbsAction';
import { selectContentTotalLength } from '../../selectors/ContentSelectors';
import { SessionUserSelectors } from '../../selectors/SessionInfoSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { AllGroupsSpace, AllGroupsSpaceDispatchProps, AllGroupsSpaceOwnProps, AllGroupsSpaceStateProps } from './AllGroupsSpace';

const mapStateToProps: MapStateToProps<AllGroupsSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedGroups: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
  canSessionUserManageUsers: SessionUserSelectors.canManageUsers(state),
});

const mapDispatchToProps: MapDispatchToProps<AllGroupsSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
  updateBreadcrumbs,
}, dispatch);

export const ConnectedAllGroupsSpace: React.ComponentClass<AllGroupsSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllGroupsSpace);
